export default "__VITE_ASSET__7d1b5eb1__"